
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/customer-engagement",
      function () {
        return require("private-next-pages/features/customer-engagement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/customer-engagement"])
      });
    }
  